export class PayInvoiceRequestModel {
    InvoiceId: number;
    PaymentAmount: number;
    PaymentToken: string = "";
}